import { TInventory, TProduct, TStore } from '@components/types';
import { cartState } from '@recoil/atoms';
import { variantState } from '@recoil/atoms/variant';
import { Minus, Plus, Trash } from 'lucide-react';
import Link from 'next/link';
import { useRecoilState } from 'recoil';
type Props = {
  product: TProduct;
  inventory: TInventory;
  btnStyle?: string;
  Isvariant?: boolean;
  store?: TStore
};

export const CartButtonV5 = ({
  product,
  inventory,
  btnStyle,
  Isvariant = false,
  store
}: Props) => {
  const [cart, setCart] = useRecoilState(cartState);
  const [Variant, setVariant] = useRecoilState(variantState);
  let inventoryObj = JSON.parse(JSON.stringify(inventory || {}))
  const internalId = Array.from(cart.values()).filter((x) => x?.inventory?.id === inventoryObj?.id)[0]?.internalId


  const increase = (product: TProduct, inventoryObj: TInventory, quantity: number = 1) => {
    let inventory: TInventory = JSON.parse(JSON.stringify(inventoryObj))
    const finalId = `${inventory?.variant?.id}${inventory?.addons.length > 0 ? "_" + inventory?.addons?.sort((a, b) => a.id - b.id).map((x) => x.id).join("_") : ""}`
    let cartItem = cart.get(finalId)
    if (product?.variants?.length > 0 && !(cartItem?.quantity > 0)) {
      setVariant({ Isvariant: true, product: product, showModal: true, quantity: productQuantity, inventory: inventory })
    }
    else if (inventory?.addons?.length > 0 && !(cartItem?.quantity > 0)) {
      setVariant({ Isvariant: true, product: product, showModal: true, quantity: productQuantity, inventory: inventory })
    }
    else {
      setCart((cart) => {
        let addons = cartItem?.addon
        if (cart.has(finalId)) {
          let newQuantity = cartItem?.quantity + quantity;
          if (newQuantity == 0 || newQuantity == undefined) {
            cart.delete(finalId);
          } else {
            cart.set(finalId, {
              internalId: finalId,
              product: product,
              quantity: newQuantity,
              inventory: inventory,
              deliverable: store?.is_delivery || inventory?.store?.is_delivery || false,
              addon: addons
            });
          }
        } else {
          cart.set(finalId, {
            internalId: finalId,
            product: product,
            quantity: quantity,
            inventory: inventory,
            deliverable: store?.is_delivery || inventory?.store?.is_delivery || false,
            addon: addons
          });
        }
        window?.fbq('track', 'AddToCart', {
          content_name: `${product?.name || inventory?.product?.name}`,
          content_category: `${product?.category?.name || inventory?.product?.category?.name}`,
          content_ids: [`${finalId || product?.id || inventory?.id}`],
          content_type: 'product',
          value: inventory?.price || product?.mrp,
          currency: 'RS'
        });
        return new Map(cart);
      });
    }
  };
  const productQuantity =
    inventory?.variant_id != undefined
      ? cart.get(internalId)?.quantity
      : 0;
  return productQuantity == 0 || productQuantity == undefined ?
    (
      inventory?.external_link?.length > 0 ?
        (
          <Link
            onClick={() => {
              window?.fbq('trackCustom', 'BuyNowClicked', {
                link: inventory?.external_link,
                content_name: `${product?.name || inventory?.product?.name}`,
                content_category: `${product?.category?.name || inventory?.product?.category?.name}`,
                content_ids: [`${product?.id || inventory?.id}`],
                content_type: 'product',
                value: inventory?.price || product?.mrp,
                currency: 'RS'
              });
            }}
            href={inventory?.external_link}
            className="box-border h-9 w-full bg-brand-500 text-neutral-50 hover:brightness-110 transition-all px-3 text-sm text-center font-semibold whitespace-nowrap select-none rounded-full font-manrope cursor-pointer flex items-center justify-center shadow-sm"
          >
            BUY NOW
          </Link>
        ) :
        (
          <button
            onClick={() => increase(product, inventory)}
            className="box-border h-9 w-full text-business-500 bg-white hover:bg-business-500/5 transition-colors px-3 text-sm text-center font-bold whitespace-nowrap select-none border-2 border-business-500 rounded-full font-manrope cursor-pointer"
          >
            ADD
          </button>
        )
    )
    :
    (
      <div className="box-border flex items-center justify-between w-full h-9 rounded-full border-2 border-business-500 overflow-hidden">
        <button
          className="flex items-center justify-center h-full px-2.5 text-business-500 hover:bg-business-500/10 transition-colors cursor-pointer"
          onClick={(event) => increase(product, inventory, -1)}
          title={productQuantity == 1 ? "Remove item" : "Decrease quantity"}
        >
          {productQuantity == 1 ? <Trash size={14} /> : <Minus size={14} />}
        </button>
        <span className="font-manrope font-semibold text-sm text-business-500">{productQuantity}</span>
        <button
          className="flex items-center justify-center h-full px-2.5 text-business-500 hover:bg-business-500/10 transition-colors cursor-pointer"
          onClick={(event) => increase(product, inventory)}
          title="Increase quantity"
        >
          <Plus size={14} />
        </button>
      </div>
    );
};
